import { configureStore } from "@reduxjs/toolkit";
import sidebarReducer from "../slices/sidebar";
import authReducer from "../slices/auth";
import themeReducer from "../slices/theme";

export const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
    auth: authReducer,
    theme: themeReducer,
  },
});
